import type { IconWeight, Icon as PhosphorIcon } from "@phosphor-icons/react";
import { cn } from "../utils";

// Thin wrapper around any Phosphor icon component. Consumers pass the
// icon component itself via the `icon` prop — no static allowlist, so
// only the icons each consumer renders end up in their bundle. Tree-
// shaking works.
//
//   import { Brain } from "@phosphor-icons/react";
//   import { Icon } from "@lua-ai-global/ui";
//
//   <Icon icon={Brain} weight="bold" className="size-4" />
//
// The wrapper exists to:
//   - default size + weight,
//   - apply `shrink-0` so icons don't squish in flex contexts,
//   - auto-set `aria-hidden` when no `aria-label` is provided
//     (decorative icons should be invisible to AT).

export interface IconProps {
  icon: PhosphorIcon;
  weight?: IconWeight;
  size?: number | string;
  className?: string;
  "aria-label"?: string;
  "aria-hidden"?: boolean | "true" | "false";
}

export function Icon({
  icon: Component,
  weight = "regular",
  size = 20,
  className,
  ...rest
}: IconProps) {
  const decorative = rest["aria-label"] === undefined;
  return (
    <Component
      weight={weight}
      size={size}
      className={cn("shrink-0", className)}
      aria-hidden={decorative ? true : rest["aria-hidden"]}
      {...rest}
    />
  );
}
